import { STATE } from '../constants';

const idVerifyBranch = STATE.UI.ID_VERIFY;
const sdkLoadingPath = idVerifyBranch.SDK_LOADING;
const sdkInitializedPath = idVerifyBranch.SDK_INITIALIZED;
const sdkLoading = state => state.getIn(sdkLoadingPath);
const sdkInitialized = state => state.getIn(sdkInitializedPath);


export default {
  sdkLoading,
  sdkInitialized
};
